import { motion, useCycle, Variants } from "framer-motion";

const TextLoadingAnimation = () => {
  /**
   * Variant definitions
   */
  const threeDotsContainer: Variants = {
    hidden: { opacity: 0, transition: { duration: 0.5 } },
    show: {
      opacity: [0, 1, 1, 1, 1, 1],
      transition: {
        staggerChildren: 0.5,
        duration: 2.5,
      },
    },
  };

  const dotItem: Variants = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  };

  // Hook to animate the three dots
  const [animationState, cycleFunction] = useCycle("show", "hidden");

  return (
    <motion.span
      variants={threeDotsContainer}
      initial="hidden"
      animate={animationState}
      onAnimationComplete={() => cycleFunction()}
    >
      <motion.span variants={dotItem}>.</motion.span>
      <motion.span variants={dotItem}>.</motion.span>
      <motion.span variants={dotItem}>.</motion.span>
    </motion.span>
  );
};

export default TextLoadingAnimation;
